import React from 'react';
import { colors } from '../styles/styles';
import PrimaryButton from './common/PrimaryButton';

// Shown after the user clears the last card in the review queue. Stays
// in place until the user dismisses, so the completion registers
// rather than yanking them straight back to the list.
const DraftsExhaustedView = ({ total, onDismiss }) => (
  <div
    style={{
      width: '100%',
      maxWidth: 720,
      margin: '0 auto',
      padding: '60px 24px',
      textAlign: 'center',
      color: colors.textPrimary,
    }}
  >
    <div
      aria-hidden="true"
      style={{
        width: 64,
        height: 64,
        margin: '0 auto 24px',
        borderRadius: 32,
        background: `${colors.accent.purple}20`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
        <path
          d="M5 12L10 17L20 7"
          stroke={colors.accent.purple}
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
    <h3
      style={{
        fontSize: 22,
        fontWeight: 600,
        margin: '0 0 8px',
        letterSpacing: '-0.01em',
      }}
    >
      All caught up
    </h3>
    <p
      style={{
        color: colors.textSecondary,
        margin: '0 0 32px',
        fontSize: 15,
        lineHeight: 1.5,
      }}
    >
      You worked through {total} {total === 1 ? 'draft' : 'drafts'}.
    </p>
    <PrimaryButton onClick={onDismiss} testId="drafts-review-dismiss">
      Back to drafts
    </PrimaryButton>
  </div>
);

export default DraftsExhaustedView;
